import { useEffect, useState } from 'react'
import Loading from '../loading/loading'

const CachePersister = ({ children }) => {
	const [isHydrated, setIsHydrated] = useState(false)

	useEffect(() => {
		// Marcar como hidratado después del primer render
		setIsHydrated(true)
	}, [])

	// Mostrar loading mientras se hidrata el cache
	if (!isHydrated) {
		return <Loading small />
	}

	return children
}

export default CachePersister
